/* ============================================================
   Flamel Analytics — Instrumentación CRO (Hero + Kit entry)
   Cliente: Redi Food (redifood.co)
   Generated: 2026-06-19 por flamel-analytics-dept (experimentos CRO)
   Spec ref: clients/redifood/deliverables/2026-06-19/hero-kit-instrumentation-spec.md

   AÑADE los eventos nuevos requeridos por los 2 experimentos CRO, SIN tocar la
   instrumentación v1 (theme-datalayer-events.js sigue igual). Cargar DESPUÉS de
   flamel-datalayer-events.js.

   INSTALACIÓN:
   1. Subir a `assets/flamel-cro-events.js`
   2. En layout/theme.liquid, tras el script de flamel-datalayer-events.js:
        {{ 'flamel-cro-events.js' | asset_url | script_tag }}
   3. Marcar en el theme:
        - El contenedor del HERO con  data-flamel-hero  (y opcional data-hero-variant="control|v2")
        - El CTA del hero que lleva al armado de kit con  data-flamel-cta="kits_hero"
        - El contenedor del kit builder con  data-flamel-kit-builder
      (Si la UI del kit emite CustomEvents, también se escucha flamel:kit:view.)

   EVENTOS QUE EMITE (dataLayer):
     - hero_section_view  { hero_id, hero_variant, hero_dwell_ms }   (1×/sesión, al flush)
     - cta_kits_hero      { hero_id, hero_variant }
     - kit_builder_view   { kit_entry }                              (1×/sesión)

   COMPAT: ES5+, sin dependencias. Reusa los mismos patrones que v1.
   ============================================================ */

(function () {
  "use strict";

  window.dataLayer = window.dataLayer || [];

  function dlPush(eventName, extras) {
    var payload = { event: eventName };
    if (extras) {
      Object.keys(extras).forEach(function (k) {
        payload[k] = extras[k];
      });
    }
    window.dataLayer.push(payload);
  }

  /* Clarity mirror (no-op si Clarity no está instalado) */
  function clarityEvent(n) {
    if (typeof window.clarity === "function") {
      try {
        window.clarity("event", n);
      } catch (e) {}
    }
  }

  var SS = window.sessionStorage;
  function once(key) {
    try {
      if (SS.getItem(key)) return false;
      SS.setItem(key, "1");
      return true;
    } catch (e) {
      return true; // si sessionStorage falla, no bloqueamos el evento
    }
  }

  /* ========================================================
     EXP-02 — HERO SECTION
     ========================================================
     Estrategia para "tiempo de visualización": acumulamos el tiempo en que el
     hero está ≥50% visible (IntersectionObserver) y disparamos UN solo
     hero_section_view por sesión con hero_dwell_ms en el primer flush:
       - el hero sale de viewport tras haber sido visto, o
       - visibilitychange -> hidden, o
       - beforeunload (cierre/navegación), o
       - clic en el CTA del hero.
  */
  (function initHero() {
    // Selectores reales del hero de Redi (sections/hero-redi.liquid): la <section>
    // lleva [data-rf-hero] y el CTA es .rf-hero__cta. La variante vive en data-theme
    // (opt1|opt2|cream|forest). Fallback a los data-flamel-* por si se renombra.
    var hero = document.querySelector("[data-rf-hero], .rf-hero, [data-flamel-hero]");
    if (!hero || typeof IntersectionObserver !== "function") return;

    var heroId = hero.getAttribute("data-hero-id") || "home_hero";
    var heroVariant =
      hero.getAttribute("data-theme") ||
      hero.getAttribute("data-hero-variant") ||
      "control";

    var visibleSince = 0; // timestamp en que entró a ≥50%
    var dwellMs = 0; // acumulado
    var seen = false;
    var flushed = false;

    function accumulate() {
      if (visibleSince) {
        dwellMs += Date.now() - visibleSince;
        visibleSince = 0;
      }
    }

    function flush(reason) {
      if (flushed) return;
      if (!seen) return;
      accumulate();
      flushed = true;
      dlPush("hero_section_view", {
        hero_id: heroId,
        hero_variant: heroVariant,
        hero_dwell_ms: Math.round(dwellMs),
        flush_reason: reason || ""
      });
      clarityEvent("hero_section_view");
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            seen = true;
            if (!visibleSince) visibleSince = Date.now();
          } else {
            // salió de viewport tras haber sido visto -> contabiliza y flush
            accumulate();
            if (seen) flush("scrolled_out");
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );
    obs.observe(hero);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) flush("visibility_hidden");
    });
    window.addEventListener("beforeunload", function () {
      flush("beforeunload");
    });

    /* CTA del hero -> cta_kits_hero + asegura el flush del view */
    function bindCta() {
      // CTA real del hero: <a class="rf-hero__cta" ... data-promo-id="hero_kit">
      var cta = document.querySelector(
        '.rf-hero__cta, [data-promo-id="hero_kit"], [data-flamel-cta="kits_hero"]'
      );
      if (!cta) return;
      cta.addEventListener("click", function () {
        flush("cta_click");
        dlPush("cta_kits_hero", { hero_id: heroId, hero_variant: heroVariant });
        clarityEvent("cta_kits_hero");
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bindCta);
    } else {
      bindCta();
    }
  })();

  /* ========================================================
     BANNER de home → kit (cta_kits_banner)
     ========================================================
     Sección rf-kitbanner: CTA .rf-kb__cta (data-promo-id="kit_banner",
     slot home_banner) que también lleva a /pages/arma-tu-kit. */
  (function initBannerCta() {
    function bind() {
      var cta = document.querySelector('.rf-kb__cta, [data-promo-id="kit_banner"]');
      if (!cta) return;
      cta.addEventListener("click", function () {
        dlPush("cta_kits_banner", { cta_location: "home_banner" });
        clarityEvent("cta_kits_banner");
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bind);
    } else {
      bind();
    }
  })();

  /* ========================================================
     EXP-01 — KIT BUILDER: evento de ENTRADA (kit_builder_view)
     ========================================================
     Cierra el gap del funnel ("usuarios que entraron"). 1×/sesión.
     Tres vías (la primera que ocurra):
       A) CustomEvent del theme/app:  document.dispatchEvent(new CustomEvent('flamel:kit:view'))
       B) IntersectionObserver sobre [data-flamel-kit-builder]
       C) match de URL del builder (data-attribute kit_entry='url')
  */
  (function initKitView() {
    function fireView(entry) {
      if (!once("flamel_kit_view")) return;
      dlPush("kit_builder_view", { kit_entry: entry || "" });
      clarityEvent("kit_builder_view");
    }

    // A) hook explícito
    document.addEventListener("flamel:kit:view", function () {
      fireView("custom_event");
    });

    // B) observer sobre el contenedor
    function bindObserver() {
      // Contenedor real donde monta la app React del kit: <div id="rk-root">
      var el = document.querySelector("#rk-root, [data-flamel-kit-builder]");
      if (el && typeof IntersectionObserver === "function") {
        var o = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                fireView("intersection");
                o.disconnect();
              }
            });
          },
          { threshold: 0.3 }
        );
        o.observe(el);
      } else if (el) {
        fireView("present_on_load");
      }
    }

    // C) match de URL — path confirmado del builder en producción
    var KIT_PATHS = ["/pages/arma-tu-kit"];
    function checkUrl() {
      var p = window.location.pathname.toLowerCase();
      for (var i = 0; i < KIT_PATHS.length; i++) {
        if (p.indexOf(KIT_PATHS[i]) !== -1) {
          fireView("url_match");
          return;
        }
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        bindObserver();
        checkUrl();
      });
    } else {
      bindObserver();
      checkUrl();
    }
  })();

  /* ========================================================
     EXP-01 — FUNNEL del kit: traduce los CustomEvents del configurador
     (rk-app.jsx → fireKit) a eventos GA4 kit_builder_*. Autocontenido: NO
     depende del bridge v1, así que no hay doble conteo. Los tags GTM
     kit_builder_start/add_item/complete/abandon ya existen en el container v1.
     ======================================================== */
  (function initKitFunnel() {
    function ccy() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "COP";
    }
    var itemsCount = 0;

    document.addEventListener("flamel:kit:start", function (e) {
      var d = e.detail || {};
      itemsCount = 0;
      dlPush("kit_builder_start", { kit_type: d.kit_type || "", kit_size: d.size || "" });
      clarityEvent("kit_builder_start");
    });
    document.addEventListener("flamel:kit:add", function (e) {
      var d = e.detail || {};
      itemsCount += 1;
      dlPush("kit_builder_add_item", { items_count: itemsCount, kit_value: Number(d.total) || 0, currency: ccy() });
    });
    document.addEventListener("flamel:kit:complete", function (e) {
      var d = e.detail || {};
      dlPush("kit_builder_complete", {
        items_count: itemsCount,
        kit_value: Number(d.total) || 0,
        currency: ccy(),
        kit_type: d.kit ? String(d.kit) : "",
      });
      clarityEvent("kit_builder_complete");
    });
    document.addEventListener("flamel:kit:abandon", function (e) {
      var d = e.detail || {};
      dlPush("kit_builder_abandon", { items_count: itemsCount, kit_type: d.kit ? String(d.kit) : "" });
      clarityEvent("kit_builder_abandon");
    });
  })();
})();
